import { FoodBeverageContactType } from '@api';
import { TouringCardTable, TouringCardTableBody } from '@common';
import { VenueFoodBeverageContactTableRow } from './components';
import { venueFoodBeverageContactRows } from './data';

type VenueFoodBeverageContactTablePropsType = {
  venueFoodBeverageContact: FoodBeverageContactType;
};

export const VenueFoodBeverageContactTable: React.FC<VenueFoodBeverageContactTablePropsType> = ({
  venueFoodBeverageContact,
}) => {
  return (
    <TouringCardTable>
      <TouringCardTableBody>
        {venueFoodBeverageContactRows.map((row) => (
          <VenueFoodBeverageContactTableRow
            key={row.label}
            venueFoodBeverageContact={venueFoodBeverageContact}
            row={row}
          />
        ))}
      </TouringCardTableBody>
    </TouringCardTable>
  );
};

